import Grayscale from 'lib/grayscalePublishing';
import MHStorage from 'mh-storage';

const storage = new MHStorage({
  storageEngine: localStorage,
  storageType: 'WEB',
  whiteList: ['mobile', '_crossenv'],
  keyPrefix: ''
});

const _sessionStorage = new MHStorage({
  storageEngine: sessionStorage,
  storageType: 'WEB',
  whiteList: ['mobile'],
  keyPrefix: 'web-teams'
});

export type AuthUserInfo = {
  staffId?: string;
  userId?: string;
  companyId?: string;
  orgCode?: string;
  token?: string;
  mobile?: string;
};

export type IThirdUserInfo = {
  path: string;
  accessToken: string;
  userId: string;
};

const isValidValue = (val: string): boolean => {
  return !!val && val !== 'undefined' && val !== 'null';
};

// 获取用户是否有权限访问功能
export const getUserAuth = () => isValidValue(getUserToken()) && isValidValue(getUserId()) && isValidValue(getStaffId()) && isValidValue(getCompanyId());

export const setAuthUserInfo = ({ staffId, userId, companyId, token, mobile, orgCode }: AuthUserInfo) => {
  staffId && setStaffId(staffId);
  userId && setUserId(userId);
  companyId && setCompanyId(companyId);
  orgCode && setOrgCode(orgCode);
  token && setUserToken(token);
  mobile && setMobile(mobile);
};

export const getUserId = () => storage.getSync('userId');

export const setUserId = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('userId', value);
};

export const setSessionId = (value: string) => _sessionStorage.setSync('sessionId', value, '24h');

export const getSessionId = () => _sessionStorage.getSync('sessionId');

export const clearSessionId = () => _sessionStorage.removeSync('sessionId');

export const setStaffId = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('staffId', value);
};

export const getStaffId = () => storage.getSync('staffId');

export const setCompanyId = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('companyId', value);
};

export const getCompanyId = () => storage.getSync('companyId');

export const setOrgCode = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('orgCode', value);
  Grayscale.set(value);
};

export const getOrgCode = () => storage.getSync('orgCode');

export const setMeetingTime = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('meetingTime', value);
};
export const getMeetingTime = () => storage.getSync('meetingTime');

export const setUserToken = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('userToken', value);
};
export const setTokenExpireTime = (value: string) => {
  if (!value || value === 'undefined' || value === 'null') return;
  storage.setSync('tokenExpireTime', value);
};
export const getTokenExpireTime = () => storage.getSync('tokenExpireTime');

export const getUserToken = () => storage.getSync('userToken');

export const setMobile = (value: string) => storage.setSync('mobile', value);

export const getMobile = () => storage.getSync('mobile');

export const setAccessKey = (value: string) => storage.setSync('accessKey', value);

export const getAccessKey = () => storage.getSync('accessKey');

export const setCheckedAreas = (values: string) => storage.setSync('checkedAreas', values);

export const getCheckedAreas = () => storage.getSync('checkedAreas');

export const clearCheckedAreas = () => storage.removeSync('checkedAreas');

export const getLoginRedirectUrl = () => sessionStorage.getItem('loginRedirectUrl');

export const setLoginRedirectUrl = (value: string) => sessionStorage.setItem('loginRedirectUrl', value);

export const clearLoginRedirectUrl = () => sessionStorage.removeItem('loginRedirectUrl');

export const clearLocalStorage = () => {
  storage.clear();
  Grayscale.clear();
};

export const clearStorage = () => storage.clearSync(['companyId', 'staffId', 'userToken', 'userId', 'meetingTime']);

export default storage;
